import { post } from '../AxiosConfig';

const getAgentExpenses = (payload) => {
  const URL = `/reporting/agent-cash-expense-report`;
  return post(URL, payload);
};

const downloadReport = (payload) => {
  const URL = `/reporting/export-agent-cash-expense-report`;
  return post(URL, payload);
};

const getReportByLocations = (payload) => {
  const URL = `/reporting/loading-report-by-terminal-location`;
  return post(URL, payload);
};

const getReportByReference = (payload) => {
  const URL = `/reporting/terminal-report-by-reference`;
  return post(URL, payload);
};

const getBankDetails = (payload) => {
  const URL = `/reporting/bank-details-from-reference`;
  return post(URL, payload);
};

// New functions for Withdrawal Report
const getWithdrawalCountReport = (payload) => {
  const URL = `/reporting/withdrawal-count-report`;
  return post(URL, payload);
};

// Get terminals for withdrawal report
const getTerminalsForReport = (payload) => {
  const URL = `/reporting/terminals-for-report`;
  return post(URL, payload);
};

const getLoadingGapReport = (payload) => {
  const URL = `/reporting/loading-gap-report`;
  return post(URL, payload);
};

// Check Flow Report — זרימת כסף בנק→עובד→מסוף→בנק
const getCheckFlowReport = (payload) => {
  const URL = `/reporting/check-flow-report`;
  return post(URL, payload);
};

// Employee Balance Report — יתרת עובדים (TotalToReturn פעיל)
const getEmployeeBalanceReport = (payload) => {
  const URL = `/reporting/employee-balance-report`;
  return post(URL, payload);
};

// Check Detail Report — פירוט שיק לפי מסוף/אצווה (לדוח הדפסה)
const getCheckDetail = (payload) => {
  const URL = `/reporting/check-detail-report`;
  return post(URL, payload);
};

const reportService = {
  getAgentExpenses,
  downloadReport,
  getReportByLocations,
  getReportByReference,
  getBankDetails,
  getWithdrawalCountReport,
  getTerminalsForReport,
  getLoadingGapReport,
  getCheckFlowReport,
  getEmployeeBalanceReport,
  getCheckDetail,
};

export default reportService;
